import { render, staticRenderFns } from "./ShoppingListModalConfirmButton.vue?vue&type=template&id=d271ff08&"
import script from "./ShoppingListModalConfirmButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingListModalConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports